import { render, staticRenderFns } from "./FavoritesRepairs.vue?vue&type=template&id=3377b379&scoped=true&"
import script from "./FavoritesRepairs.vue?vue&type=script&lang=js&"
export * from "./FavoritesRepairs.vue?vue&type=script&lang=js&"
import style0 from "./FavoritesRepairs.vue?vue&type=style&index=0&id=3377b379&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3377b379",
  null
  
)

export default component.exports